import React from 'react';
import cs from 'clsx';

import { FlipCard } from './flip-card';

const shouldShowBorder = (index, itemCount) => {
    if (itemCount === 1) {
        return false;
    }
    return index % 3 === 1 || (index === itemCount - 1 && index % 3 === 0);
};

export const CardRow = ({ items, cardBackground = false }) => (
    <div className="impact-card-row">
        {items.map((item, index) => (
            <FlipCard
                key={`${item.index}`}
                item={item}
                className={cs({
                    'border-element': shouldShowBorder(index, items.length),
                })}
                hasBackground={cardBackground}
            />
        ))}
    </div>
);

